module.exports = __webpack_public_path__ + "static/pic03.c0c83642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic03.jpg
// module id = 132
// module chunks = 35783957827783 65868693374900